<div class="tile-grid"
  [style.grid-template-areas]="gridTemplateAreas()"
  [style.grid-template-columns]="gridTemplateColumns()"
  [style.grid-template-rows]="gridTemplateRows()">
  @for (id of placedTileIds(); track id) {
    <app-tile [tile]="getTile(id)" [clickableTile]="clickableTile()" [style.grid-area]="id"></app-tile>
  }
</div>
